import { useSelector } from 'react-redux';

import { StoreState } from '~/reducer';
import { legalEntityStateSelector } from '~/selectors';

import { LegalEntity } from './types';

export const useAllLegalEntities = (): {
  legalEntities: LegalEntity[];
  isLoading: boolean;
  failedToLoad: boolean;
  hasData: boolean;
} => {
  return useSelector((state: StoreState) => {
    return legalEntityStateSelector(state);
  });
};
